// src/config/beatmaps.js

// 음악 BPM: 105.0
export const MUSIC_BPM = 105.0;

export const BEATMAPS = {
  easy: [
    { time: 1669, lane: 2, type: 'tap' },
    { time: 2240, lane: 1, type: 'tap' },
    { time: 2812, lane: 3, type: 'tap' },
    { time: 3383, lane: 3, type: 'tap' },
    { time: 3955, lane: 0, type: 'tap' },
    { time: 4526, lane: 1, type: 'tap' },
    { time: 5097, lane: 1, type: 'tap' },
    { time: 5669, lane: 0, type: 'tap' },
    { time: 6240, lane: 0, type: 'tap' },
    { time: 6812, lane: 1, type: 'tap' },
    { time: 7383, lane: 3, type: 'tap' },
    { time: 7955, lane: 2, type: 'tap' },
    { time: 8526, lane: 3, type: 'tap' },
    { time: 9097, lane: 0, type: 'tap' },
    { time: 9669, lane: 1, type: 'tap' },
    { time: 10240, lane: 1, type: 'tap' },
    { time: 10812, lane: 0, type: 'tap' },
    { time: 11383, lane: 2, type: 'tap' },
    { time: 11955, lane: 2, type: 'tap' },
    { time: 12526, lane: 2, type: 'tap' },
    { time: 13097, lane: 3, type: 'tap' },
    { time: 13669, lane: 2, type: 'tap' },
    { time: 14240, lane: 0, type: 'tap' },
    { time: 14812, lane: 0, type: 'tap' },
    { time: 15383, lane: 2, type: 'tap' },
    { time: 15955, lane: 2, type: 'tap' },
    { time: 16526, lane: 3, type: 'tap' },
    { time: 17097, lane: 3, type: 'tap' },
    { time: 17669, lane: 0, type: 'tap' },
    { time: 18240, lane: 3, type: 'tap' },
    { time: 18812, lane: 2, type: 'tap' },
    { time: 19383, lane: 2, type: 'tap' },
    { time: 19955, lane: 0, type: 'tap' },
    { time: 20526, lane: 3, type: 'tap' },
    { time: 21097, lane: 3, type: 'tap' },
    { time: 21669, lane: 2, type: 'tap' },
    { time: 22240, lane: 1, type: 'tap' },
    { time: 22812, lane: 3, type: 'tap' },
    { time: 23383, lane: 0, type: 'tap' },
    { time: 23955, lane: 0, type: 'tap' },
    { time: 24526, lane: 0, type: 'tap' },
    { time: 25097, lane: 2, type: 'tap' },
    { time: 25669, lane: 2, type: 'tap' },
    { time: 26240, lane: 3, type: 'tap' },
    { time: 26812, lane: 0, type: 'tap' },
    { time: 27383, lane: 2, type: 'tap' },
    { time: 27955, lane: 2, type: 'tap' },
    { time: 28526, lane: 2, type: 'tap' },
    { time: 29097, lane: 1, type: 'tap' },
    { time: 29669, lane: 3, type: 'tap' },
  ],
  normal: [
    { time: 1669, lane: 2, type: 'tap' },
    { time: 1955, lane: 0, type: 'tap' },
    { time: 2240, lane: 3, type: 'tap' },
    { time: 2526, lane: 2, type: 'tap' },
    { time: 3383, lane: 2, type: 'tap' },
    { time: 3669, lane: 2, type: 'tap' },
    { time: 3955, lane: 3, type: 'tap' },
    { time: 3955, lane: 2, type: 'tap' },
    { time: 4240, lane: 3, type: 'tap' },
    { time: 4526, lane: 2, type: 'tap' },
    { time: 4812, lane: 2, type: 'tap' },
    { time: 4812, lane: 3, type: 'tap' },
    { time: 5097, lane: 1, type: 'tap' },
    { time: 5383, lane: 0, type: 'tap' },
    { time: 5669, lane: 3, type: 'tap' },
    { time: 5955, lane: 1, type: 'tap' },
    { time: 6240, lane: 0, type: 'tap' },
    { time: 6526, lane: 3, type: 'tap' },
    { time: 6526, lane: 1, type: 'tap' },
    { time: 6812, lane: 0, type: 'tap' },
    { time: 7097, lane: 3, type: 'tap' },
    { time: 7383, lane: 0, type: 'tap' },
    { time: 7669, lane: 3, type: 'tap' },
    { time: 7955, lane: 3, type: 'tap' },
    { time: 8240, lane: 0, type: 'tap' },
    { time: 8240, lane: 1, type: 'tap' },
    { time: 8812, lane: 3, type: 'tap' },
    { time: 8812, lane: 1, type: 'tap' },
    { time: 9097, lane: 1, type: 'tap' },
    { time: 9383, lane: 0, type: 'tap' },
    { time: 9669, lane: 1, type: 'tap' },
    { time: 9669, lane: 0, type: 'tap' },
    { time: 10240, lane: 1, type: 'tap' },
    { time: 10526, lane: 3, type: 'tap' },
    { time: 10812, lane: 1, type: 'tap' },
    { time: 11097, lane: 2, type: 'tap' },
    { time: 11383, lane: 2, type: 'tap' },
    { time: 11669, lane: 0, type: 'tap' },
    { time: 11955, lane: 3, type: 'tap' },
    { time: 12240, lane: 2, type: 'tap' },
    { time: 12526, lane: 3, type: 'tap' },
    { time: 12812, lane: 2, type: 'tap' },
    { time: 12812, lane: 3, type: 'tap' },
    { time: 13097, lane: 2, type: 'tap' },
    { time: 13383, lane: 3, type: 'tap' },
    { time: 13669, lane: 3, type: 'tap' },
    { time: 13669, lane: 0, type: 'tap' },
    { time: 14240, lane: 3, type: 'tap' },
    { time: 14240, lane: 1, type: 'tap' },
    { time: 14526, lane: 2, type: 'tap' },
    { time: 14526, lane: 1, type: 'tap' },
    { time: 14812, lane: 3, type: 'tap' },
    { time: 15097, lane: 1, type: 'tap' },
    { time: 15383, lane: 0, type: 'tap' },
    { time: 15669, lane: 1, type: 'tap' },
    { time: 15955, lane: 0, type: 'tap' },
    { time: 16240, lane: 3, type: 'tap' },
    { time: 16526, lane: 0, type: 'tap' },
    { time: 16812, lane: 3, type: 'tap' },
    { time: 17097, lane: 0, type: 'tap' },
    { time: 17383, lane: 3, type: 'tap' },
    { time: 17955, lane: 1, type: 'tap' },
    { time: 18240, lane: 3, type: 'tap' },
    { time: 18526, lane: 3, type: 'tap' },
    { time: 18812, lane: 0, type: 'tap' },
    { time: 19097, lane: 0, type: 'tap' },
    { time: 19383, lane: 3, type: 'tap' },
    { time: 19955, lane: 0, type: 'tap' },
    { time: 19955, lane: 3, type: 'tap' },
    { time: 20240, lane: 1, type: 'tap' },
    { time: 20812, lane: 1, type: 'tap' },
    { time: 21383, lane: 0, type: 'tap' },
    { time: 21669, lane: 3, type: 'tap' },
    { time: 21955, lane: 2, type: 'tap' },
    { time: 22526, lane: 2, type: 'tap' },
    { time: 22812, lane: 3, type: 'tap' },
    { time: 23097, lane: 2, type: 'tap' },
    { time: 23383, lane: 2, type: 'tap' },
    { time: 23669, lane: 0, type: 'tap' },
    { time: 24240, lane: 3, type: 'tap' },
    { time: 24240, lane: 2, type: 'tap' },
    { time: 24526, lane: 2, type: 'tap' },
    { time: 24812, lane: 2, type: 'tap' },
    { time: 25097, lane: 0, type: 'tap' },
    { time: 25383, lane: 3, type: 'tap' },
    { time: 25669, lane: 2, type: 'tap' },
    { time: 25955, lane: 2, type: 'tap' },
    { time: 26240, lane: 1, type: 'tap' },
    { time: 26240, lane: 2, type: 'tap' },
    { time: 26526, lane: 1, type: 'tap' },
    { time: 26812, lane: 0, type: 'tap' },
    { time: 27097, lane: 3, type: 'tap' },
    { time: 27383, lane: 1, type: 'tap' },
    { time: 27669, lane: 2, type: 'tap' },
    { time: 27669, lane: 3, type: 'tap' },
    { time: 27955, lane: 3, type: 'tap' },
    { time: 28240, lane: 3, type: 'tap' },
    { time: 28240, lane: 2, type: 'tap' },
    { time: 28526, lane: 0, type: 'tap' },
    { time: 28812, lane: 2, type: 'tap' },
    { time: 29097, lane: 3, type: 'tap' },
    { time: 29383, lane: 1, type: 'tap' },
    { time: 29669, lane: 3, type: 'tap' },
  ],
  hard: [
    { time: 1669, lane: 0, type: 'tap' },
    { time: 1955, lane: 1, type: 'tap' },
    { time: 2240, lane: 3, type: 'tap' },
    { time: 2526, lane: 2, type: 'tap' },
    { time: 2812, lane: 0, type: 'tap' },
    { time: 3097, lane: 1, type: 'tap' },
    { time: 3097, lane: 2, type: 'tap' },
    { time: 3383, lane: 3, type: 'tap' },
    { time: 3669, lane: 2, type: 'tap' },
    { time: 3955, lane: 3, type: 'tap' },
    { time: 3955, lane: 1, type: 'tap' },
    { time: 4240, lane: 0, type: 'tap' },
    { time: 4526, lane: 3, type: 'tap' },
    { time: 4526, lane: 2, type: 'tap' },
    { time: 4812, lane: 2, type: 'tap' },
    { time: 5097, lane: 2, type: 'tap' },
    { time: 5383, lane: 1, type: 'tap' },
    { time: 5669, lane: 3, type: 'tap' },
    { time: 5955, lane: 2, type: 'tap' },
    { time: 5955, lane: 1, type: 'tap' },
    { time: 6240, lane: 0, type: 'tap' },
    { time: 6526, lane: 0, type: 'tap' },
    { time: 6812, lane: 2, type: 'tap' },
    { time: 6812, lane: 1, type: 'tap' },
    { time: 7097, lane: 2, type: 'tap' },
    { time: 7097, lane: 1, type: 'tap' },
    { time: 7383, lane: 0, type: 'tap' },
    { time: 7669, lane: 0, type: 'tap' },
    { time: 7955, lane: 1, type: 'tap' },
    { time: 8240, lane: 2, type: 'tap' },
    { time: 8526, lane: 3, type: 'tap' },
    { time: 8812, lane: 3, type: 'tap' },
    { time: 9097, lane: 2, type: 'tap' },
    { time: 9383, lane: 2, type: 'tap' },
    { time: 9669, lane: 2, type: 'tap' },
    { time: 9955, lane: 0, type: 'tap' },
    { time: 9955, lane: 2, type: 'tap' },
    { time: 10240, lane: 2, type: 'tap' },
    { time: 10240, lane: 3, type: 'tap' },
    { time: 10526, lane: 1, type: 'tap' },
    { time: 10526, lane: 3, type: 'tap' },
    { time: 10812, lane: 0, type: 'tap' },
    { time: 11097, lane: 1, type: 'tap' },
    { time: 11097, lane: 0, type: 'tap' },
    { time: 11383, lane: 2, type: 'tap' },
    { time: 11669, lane: 3, type: 'tap' },
    { time: 12240, lane: 1, type: 'tap' },
    { time: 12526, lane: 1, type: 'tap' },
    { time: 12812, lane: 0, type: 'tap' },
    { time: 13097, lane: 1, type: 'tap' },
    { time: 13383, lane: 0, type: 'tap' },
    { time: 13383, lane: 1, type: 'tap' },
    { time: 13669, lane: 2, type: 'tap' },
    { time: 13669, lane: 1, type: 'tap' },
    { time: 13955, lane: 1, type: 'tap' },
    { time: 14240, lane: 2, type: 'tap' },
    { time: 14526, lane: 3, type: 'tap' },
    { time: 14526, lane: 2, type: 'tap' },
    { time: 14812, lane: 0, type: 'tap' },
    { time: 14812, lane: 1, type: 'tap' },
    { time: 15097, lane: 1, type: 'tap' },
    { time: 15383, lane: 0, type: 'tap' },
    { time: 15669, lane: 1, type: 'tap' },
    { time: 15955, lane: 3, type: 'tap' },
    { time: 16240, lane: 1, type: 'tap' },
    { time: 16240, lane: 2, type: 'tap' },
    { time: 16526, lane: 2, type: 'tap' },
    { time: 16526, lane: 1, type: 'tap' },
    { time: 16812, lane: 0, type: 'tap' },
    { time: 16812, lane: 2, type: 'tap' },
    { time: 17097, lane: 1, type: 'tap' },
    { time: 17097, lane: 0, type: 'tap' },
    { time: 17383, lane: 3, type: 'tap' },
    { time: 17383, lane: 0, type: 'tap' },
    { time: 17669, lane: 2, type: 'tap' },
    { time: 17669, lane: 0, type: 'tap' },
    { time: 17955, lane: 1, type: 'tap' },
    { time: 18240, lane: 3, type: 'tap' },
    { time: 18240, lane: 0, type: 'tap' },
    { time: 18526, lane: 3, type: 'tap' },
    { time: 18526, lane: 2, type: 'tap' },
    { time: 18812, lane: 0, type: 'tap' },
    { time: 19097, lane: 0, type: 'tap' },
    { time: 19097, lane: 1, type: 'tap' },
    { time: 19383, lane: 1, type: 'tap' },
    { time: 19669, lane: 1, type: 'tap' },
    { time: 19669, lane: 0, type: 'tap' },
    { time: 19955, lane: 1, type: 'tap' },
    { time: 20240, lane: 3, type: 'tap' },
    { time: 20526, lane: 2, type: 'tap' },
    { time: 20812, lane: 0, type: 'tap' },
    { time: 21097, lane: 0, type: 'tap' },
    { time: 21383, lane: 1, type: 'tap' },
    { time: 21669, lane: 0, type: 'tap' },
    { time: 21669, lane: 3, type: 'tap' },
    { time: 21955, lane: 3, type: 'tap' },
    { time: 22240, lane: 3, type: 'tap' },
    { time: 22240, lane: 0, type: 'tap' },
    { time: 22526, lane: 0, type: 'tap' },
    { time: 22526, lane: 3, type: 'tap' },
    { time: 22812, lane: 0, type: 'tap' },
    { time: 23097, lane: 1, type: 'tap' },
    { time: 23383, lane: 1, type: 'tap' },
    { time: 23669, lane: 0, type: 'tap' },
    { time: 23669, lane: 3, type: 'tap' },
    { time: 23955, lane: 0, type: 'tap' },
    { time: 23955, lane: 2, type: 'tap' },
    { time: 24240, lane: 2, type: 'tap' },
    { time: 24526, lane: 2, type: 'tap' },
    { time: 24526, lane: 0, type: 'tap' },
    { time: 25097, lane: 3, type: 'tap' },
    { time: 25383, lane: 0, type: 'tap' },
    { time: 25669, lane: 3, type: 'tap' },
    { time: 25955, lane: 3, type: 'tap' },
    { time: 26240, lane: 0, type: 'tap' },
    { time: 26240, lane: 2, type: 'tap' },
    { time: 26526, lane: 1, type: 'tap' },
    { time: 26526, lane: 0, type: 'tap' },
    { time: 26812, lane: 1, type: 'tap' },
    { time: 26812, lane: 2, type: 'tap' },
    { time: 27097, lane: 0, type: 'tap' },
    { time: 27669, lane: 2, type: 'tap' },
    { time: 27669, lane: 3, type: 'tap' },
    { time: 27955, lane: 3, type: 'tap' },
    { time: 28240, lane: 1, type: 'tap' },
    { time: 28526, lane: 2, type: 'tap' },
    { time: 28812, lane: 3, type: 'tap' },
    { time: 28812, lane: 2, type: 'tap' },
    { time: 29097, lane: 0, type: 'tap' },
    { time: 29383, lane: 2, type: 'tap' },
    { time: 29383, lane: 3, type: 'tap' },
    { time: 29669, lane: 0, type: 'tap' },
    { time: 29955, lane: 1, type: 'tap' },
  ],
}; 
